const ErrorsModule = () => import('@pages/errors/ErrorsModule.vue')
const Unauthorized = () => import('@pages/errors/401.vue')

export default {
    path: '/errors',
    component: ErrorsModule,
    children: [
        {
            path: 'unauthorized',
            component: Unauthorized,
            name: 'errors.unauthorized',
        },
    ],
}
